import getReducerHandler from '../../providers/getReducerHandler'
import handleReducerSimpleSetter from '../../providers/handleReducerSimpleSetter'

/*
 * --- INDIVIDUAL ACTION HANDLERS ---
 * (Set multiple values & merge/processing logic only, otherwise use handleReducerSimpleSetter)
 */

const handleSetFamilyGroups = (state, action) => {
  const familyGroups = action.value.familyGroups
  return { ...state, familyGroups, familyGroup: familyGroups[0] }
}

const handleSetShowFamilyGroupPrompt = (state, action) => {
  localStorage.setItem('fs.discovery.hasShownAddFamilyGroupPrompt', !action.value)
  return { ...state, showAddFamilyGroupPrompt: action.value }
}

// --- Handlers registry ---
const handlers = {
  SET_FAMILY_GROUP: handleReducerSimpleSetter,
  SET_FAMILY_GROUPS: handleSetFamilyGroups,
  SET_SHOW_FAMILY_GROUP_PROMPT: handleSetShowFamilyGroupPrompt,
}

export default function familyGroupReducer(state, action) {
  return getReducerHandler(state, action, handlers)
}
